import React from "react";
const PrivacyPolicy = () => (
  <div
    style={{
      maxWidth: 800,
      margin: "2rem auto",
      padding: "2rem",
      background: "#fff",
      color: "#222",
      borderRadius: 12,
      boxShadow: "0 4px 24px #0001",
      fontFamily: "Inter, Arial, sans-serif",
      lineHeight: 1.7,
    }}
  >
    <h1
      style={{
        fontSize: "2.2rem",
        fontWeight: 800,
        marginBottom: "1.5rem",
        color: "#7C3AED",
      }}
    >
      Privacy Policy
    </h1>
    <p style={{ color: "#666", fontSize: "1rem", marginBottom: "1.5rem" }}>
      <strong>Last Updated:</strong> [10, 2025]
    </p>

    <h2 style={{ marginTop: "2rem", color: "#A855F7", fontSize: "1.3rem" }}>
      1. Overview
    </h2>
    <p>
      BitcoinFOMO (“Company,” “we,” “our,” or “us”) respects your privacy. This
      Privacy Policy explains how we collect, use, and safeguard information you
      provide when you visit bitcoinfomo.io or related sub-domains (the “Site”).
      By using the Site, you consent to the practices described in this Policy.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      2. Information We Collect
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>
        <strong>Email Address:</strong> If you choose to join our update list,
        we collect the email address you voluntarily provide.
      </li>
      <li>
        <strong>Automatic Data:</strong> Like most websites, we may collect
        limited technical information (e.g., IP address, browser type, pages
        visited) through cookies or similar technologies for site functionality
        and analytics.
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      3. How We Use Your Information
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>
        Send occasional project updates or launch announcements (only if you
        subscribed).
      </li>
      <li>Operate, maintain, and improve the Site.</li>
      <li>Comply with legal obligations and protect our rights.</li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      4. Legal Bases for Processing (EU/UK Visitors)
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>
        <strong>Consent:</strong> when you voluntarily subscribe to our email
        list.
      </li>
      <li>
        <strong>Legitimate Interests:</strong> to maintain basic site security
        and functionality.
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      5. Sharing & Disclosure
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>We do not sell or rent your personal information.</li>
      <li>
        We may share data only with:
        <ul style={{ marginLeft: "1.5rem" }}>
          <li>
            <strong>Service Providers</strong> who help operate our email list
            or website (bound by confidentiality agreements).
          </li>
          <li>
            <strong>Legal Authorities</strong> if required by law or to protect
            our rights.
          </li>
        </ul>
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      6. Cookies & Tracking
    </h2>
    <p>
      We may use first-party cookies for essential site performance and
      anonymous analytics. You can control cookies through your browser
      settings.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      7. Data Retention
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>
        Email addresses are retained until you unsubscribe or request deletion.
      </li>
      <li>
        Technical logs are retained for a reasonable period for security and
        maintenance.
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      8. Your Rights
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>Access, correct, or delete your personal data.</li>
      <li>Withdraw consent or object to processing.</li>
      <li>Request data portability.</li>
    </ul>
    <p>
      To exercise these rights, email us at{" "}
      <a href="mailto:privacy@bitcoinfomo.io">privacy@bitcoinfomo.io</a>.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      9. Data Security
    </h2>
    <p>
      We use commercially reasonable safeguards to protect your information, but
      no method of transmission or storage is completely secure.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      10. International Transfers
    </h2>
    <p>
      Your information may be processed in countries outside your residence,
      including the United States. We take appropriate steps to ensure an
      adequate level of protection.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      11. Children’s Privacy
    </h2>
    <p>
      The Site is not directed to individuals under 18. We do not knowingly
      collect personal information from children.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      12. Changes to This Policy
    </h2>
    <p>
      We may update this Privacy Policy from time to time. Material changes will
      be posted on this page with a new “Last updated” date.
    </p>
  </div>
);
export default PrivacyPolicy;
